import React from 'react';

import Drawer, { DrawerProps } from '@mui/material/Drawer';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';

export function DetailsDrawer({ children, ...props }: DrawerProps) {
  return (
    <Drawer
      {...props}
      anchor={'right'}
      slotProps={{
        ...props.slotProps,
        paper: {
          ...props.slotProps?.paper,
          sx: {
            backgroundColor: 'transparent',
            padding: 3,
            ...(props.slotProps?.paper as any)?.sx,
          },
        },
      }}
    >
      <Slide direction="left" in={props.open} mountOnEnter={true} unmountOnExit={true}>
        <Stack
          bgcolor="background.paper"
          borderRadius={2}
          height="100%"
          overflow="auto"
          padding={3}
          position="relative"
        >
          {children}
        </Stack>
      </Slide>
    </Drawer>
  );
}
